// extracted by mini-css-extract-plugin
export default {"empty":"EmptySimple_empty__qhxms"};